export type CoolOffPeriodTranslations = {
  // Cool-off mode (AA not completed)
  coolingOffPeriodTitle: string;
  coolingOffPeriodDescription1: string;
  coolingOffPeriodDescription2: string;
  goToFinancialQuizButton: string;
  goToBitpandaAcademyButton: string;
  coolingOffPeriodEnds: string;
  // Cool-off mode (AA completed) — "Almost there"
  almostThereTitle: string;
  almostThereDescription: string;
  gotItButton: string;
  // Initial "Almost there" (first visit after user creation)
  initialCheckingDetails: string;
  initialRegulationText: string;
  initialExploreText: string;
  // Waiting period mode
  waitingPeriodTitle: string;
  waitingPeriodEnds: string;
  waitingPeriodDescription1: string;
  waitingPeriodDescription2: string;
  goToAcademyButton: string;
  retryFinancialQuizButton: string;
  waitingPeriodTimerDescription: string;
  // Trade intercept — waiting period active
  tradeWaitingPeriodDescription: string;
};

const translationKeys: Record<keyof CoolOffPeriodTranslations, string> = {
  // Cool-off (AA not completed)
  coolingOffPeriodTitle: 'cooling_off_period_title',
  coolingOffPeriodDescription1: 'cooling_off_period_description_1',
  coolingOffPeriodDescription2: 'cooling_off_period_description_2',
  goToFinancialQuizButton: 'go_to_financial_quiz_button',
  goToBitpandaAcademyButton: 'go_to_bitpanda_academy_button',
  coolingOffPeriodEnds: 'cool_off_period_ends',
  // Cool-off (AA completed)
  almostThereTitle: 'almost_there_title',
  almostThereDescription: 'almost_there_description',
  gotItButton: 'got_it_button',
  // Initial "Almost there" (first visit)
  initialCheckingDetails: 'cool_off_almost_there_checking_details',
  initialRegulationText: 'cool_off_almost_there_regulation_text',
  initialExploreText: 'cool_off_almost_there_explore_text',
  // Waiting period
  waitingPeriodTitle: 'waiting_period_title',
  waitingPeriodEnds: 'waiting_period_ends',
  waitingPeriodDescription1: 'waiting_period_description_1',
  waitingPeriodDescription2: 'waiting_period_description_2',
  goToAcademyButton: 'go_to_academy_button',
  retryFinancialQuizButton: 'retry_financial_quiz_button',
  waitingPeriodTimerDescription: 'waiting_period_timer_description',
  // Trade intercept — waiting period active
  tradeWaitingPeriodDescription: 'uk_trade_cool_off_waiting_description',
};

export const getCoolOffPeriodTranslations = (
  t: (param: string) => string,
): CoolOffPeriodTranslations => {
  return Object.entries(translationKeys).reduce((acc, [key, value]) => {
    acc[key as keyof CoolOffPeriodTranslations] = t(value);

    return acc;
  }, {} as CoolOffPeriodTranslations);
};
